const PasoTres = ({setPaso, setViewCovid}) => { 
    const handleClick = ()=> {
        setPaso(0)
        setViewCovid(false)
    }
    return (
        <div className="ptur-covidProto-container">
            <div className="ptur-covidProto-header bgcG-latex30">
                <h1 className="rb24t widthPasoDos">Protocolo posibles casos de coronavirus</h1>
            </div>
            <div className="ptur-covidProto-body">
                <span className="rb16m">
                    Debe llamar a <span className="span-bold">Emergencias de su cobertura médica</span>
                    o al <span className="span-bold">148</span>, para ser trasladadoo a un centro con internación
                    y <span  className="span-bold">realizar análisis para COVID 19.</span>
                </span>
                <span className="rb16m">
                    En casos que pudiera trasladarse por sus medios,
                    <span className="span-bold">coloquese un barbijo</span> y <span className="span-bold">dirigase a un centro con internacion COVID 19.</span>
                </span>
            </div>
            <button className="bgc-primary" onClick={handleClick}>Aceptar y continuar</button>
        </div>
    )
}

export default PasoTres; 